<app-top-nav
  *ngIf="
    (authService.loggedIn$ | async) &&
    layout.showLayout &&
    navReady
  "
  [sidebarOpen]="layout.isSidebarOpen"
  (toggleSidebar)="toggleSidebar()"
>
</app-top-nav>

<app-side-nav
  class="side-nav"
  [style.display]="sideNavVisible ? '' : 'none'"
>
</app-side-nav>

<div
  *ngIf="
    layout.showLayout &&
    layout.isMobileView &&
    layout.isSidebarOpen
  "
  class="sidebar-overlay"
  (click)="closeSidebar()"
>
</div>

<div
  class="main-content"
  [class.expanded]="
    !layout.isSidebarOpen ||
    layout.isMobileView ||
    !layout.isSidebarVisible
  "
  [class.public-page]="!layout.showLayout"
>
  <router-outlet></router-outlet>
</div>